<template>
    <div>
        <template v-if="type === 'text'">
            <v-text-field
                v-model="item[key]"
                :readonly="readonly"
                :label="label"
                :dense="dense"
            />
        </template>

        <template v-else-if="type === 'textarea'">
            <v-textarea
                v-model="item[key]"
                :readonly="readonly"
                :label="label"
                :dense="dense"
            />
        </template>

        <template v-else-if="type === 'switch'">
            <v-switch
                v-model="item[key]"
                :readonly="readonly"
                :label="label"
                :dense="dense"
            />
        </template>

        <template v-else-if="type === 'checkbox'">
            <v-checkbox
                v-model="item[key]"
                :readonly="readonly"
                :label="label"
                :dense="dense"
            />
        </template>

        <template v-else-if="type === 'chip'">
            <v-chip>
                {{ item[key] }}
            </v-chip>
        </template>

        <template v-else>
            {{ item[key] }}
        </template>
    </div>
</template>

<script>
export const supportedTypes = ['text', 'textarea', 'chip', 'switch', 'checkbox'];

export default {
    name: "DynamicInput",

    props: {
        item: {
            type: Object,
            require: true,
        },

        config: {
            type: Object,
            default: () => ({
                type: 'string',
            }),
        },

        readonly: {
            type: Boolean,
            default: false,
        },

        stringAsText: {
            type: Boolean,
            default: false,
        },

        hideLabel: {
            type: Boolean,
            default: false,
        },

        dense: {
            type: Boolean,
            default: false,
        },
    },

    computed: {
        type() {
            return this.config.type;
        },

        key() {
            return this.config.id;
        },

        label() {
            if(this.hideLabel){
                return undefined;
            }

            return this.config.title;
        },
    }
}
</script>

<style scoped>

</style>
